import { fetchAuthSession } from "@aws-amplify/auth";
import { post } from "@aws-amplify/api";
import { get } from '@aws-amplify/api';

const SubBuNameMap = {
  WSRS: "RIS-FSA",
  ANNUITIES: "RIS-ANN",
  BANK: "RIS-BANK",
  DTC: "RIS-DTC",
  PSI: "RIS-PSI",
  PCS: "RIS-PCS",
};

const fetchAdGroup = (project) => {
  return fetch(
    `https://api.theprincipal.net/retirement/v1/metrics/metadata/public/project/${project}/property?name=adminADGroup`,
    {
      headers: {
        "Content-Type": "text/plain",
      },
    }
  )
    .then((res) => {
      if (!res.ok) {
        throw Error(res.statusText);
      }
      return res.text();
    })
    .then((text) => {
      this.props.updateStore({
        adGroup: text,
      });
      if (text.length === 0) {
        this.setState({ customAdGroup: true });
      } else {
        this.setState({ customAdGroup: false });
      }
    })
    .catch((err) => {
      this.setState({ customAdGroup: true });
    });
};

const constructComponentName = (subBu, gitURL) => {
  let name = getRepositoryNameFromGitUrl(gitURL);
  if (name) {
    return SubBuNameMap[subBu] + "_" + name;
  }
};


const constructProductComponentName = (subBu, project) => {

  if (project) {
    return SubBuNameMap[subBu] + "_" + project;
  } else {
    return null;
  }
};

const constructProxyComponentName = (subBu, virtualPath) => {
  let name = virtualPath ? virtualPath.replace(/\//g, "-").replace(/^-+|-+$/g, '') : null;
  if (name) {
    return SubBuNameMap[subBu] + "_" + name;
  } else {
    return null;
  }
};

const constructConsumerOrProxyGroupName = (gitURL) => {
  if (isBitbucketOrGithub(gitURL, SCM_PREFIX_PATTERN) == "github") {
    return getRepositoryNameFromGitHubUrl(gitURL);
  } else {
    return getRepositoryNameFromGitUrl(gitURL);
  }
};

const constructProxyGroupPrefix = (subBu) => {
  return SubBuNameMap[subBu] + "_";
};


  const validateIfProxyAlreadyExists = async (classObject, proxyName) => {

     let selectedEnvs = classObject.props.getStore().buildEnvironment.split(",").sort((a, b) => {
      const order = ["TEST", "PILOT", "PRODUCTION"];
      return order.indexOf(a) - order.indexOf(b);
    });

    // Map environment to Lambda API paths
    const envPathMap = {
      'PRODUCTION': `/prod/proxies/${proxyName}`,
      'PILOT': `/pilot/proxies/${proxyName}`,
      'TEST': `/test/proxies/${proxyName}`
    };

    const apiName = 'Get Apigee Info API';
    const fetchPromises = [
      fetchLambdaApis(apiName, envPathMap['PRODUCTION'], null)
        .then((json) => json.name ? [json.name] : [])
        .catch(() => []),
      fetchLambdaApis(apiName, envPathMap['PILOT'], null)
        .then((json) => json.name ? [json.name] : [])
        .catch(() => []),
      fetchLambdaApis(apiName, envPathMap['TEST'], null)
        .then((json) => json.name ? [json.name] : [])
        .catch(() => [])
    ];

    return Promise.all(fetchPromises)
      .then(async ([prod, pilot, test]) => {

       let proxyMissingEnv = [];
      for(let i = 0; i < selectedEnvs.length; i++){

        if(selectedEnvs[i] === ("PRODUCTION")){
          if(null !== prod || prod.length > 0){
            if(prod.includes(proxyName)){
            proxyMissingEnv.push("PRODUCTION");
            }
          }

        }else if(selectedEnvs[i] === ("PILOT")){
          if(null !== pilot || pilot.length > 0){
            if(pilot.includes(proxyName)){
            proxyMissingEnv.push("PILOT");
            }
          }
        }
        else if(selectedEnvs[i] === ("TEST")){
          if(null !== test || test.length > 0){
            if(test.includes(proxyName)){
            proxyMissingEnv.push("TEST");
            }
          }
        }
      }

    classObject.setState({singleProxyEnv: proxyMissingEnv.join(",")});

		if(Array.isArray(proxyMissingEnv) && proxyMissingEnv.length > 0){
			classObject.setState({singleProxyEnvError:true});
			classObject.props.updateStore({isSubmit: true});
		}

    });

    }
const validateProxyExistsWithProduct = async (classObject, proxyName, proxyGroupName, isCreateNewProxy) => {
    classObject.props.updateStore({ adGroup: '' });
    classObject.setState({ adGroup: '' });
    let apiFetchFailed = false;

    let selectedEnvs = classObject.props.getStore().buildEnvironment.split(",").sort((a, b) => {
        const order = ["TEST", "PILOT", "PRODUCTION"];
        return order.indexOf(a) - order.indexOf(b);
    });

    // Map env to Lambda API paths
    const envPathMap = {
        "PRODUCTION": `/prod/products/${proxyGroupName}`,
        "PILOT": `/pilot/products/${proxyGroupName}`,
        "TEST": `/test/products/${proxyGroupName}`
    };

    const apiName = 'Get Apigee Info API';

    // Only fetch endpoints for selectedEnvs
    const fetchPromises = selectedEnvs.map(async (env) => {
        const path = envPathMap[env];
        try {
            const json = await fetchLambdaApis(apiName, path, null);

            if (!json || Object.keys(json).length === 0) {
                classObject.props.updateStore({ adGroup: '' });
                classObject.setState({ adGroup: '' });
            }
            return {
                env,
                proxies: Array.isArray(json.proxies) ? json.proxies : [],
                product_owner_group: json.product_owner_group || null,
                name: json.name || null
            };
        } catch (error) {
            console.error(`Error fetching from ${path}:`, error);
            apiFetchFailed = true;
            return {
                env,
                proxies: [],
                product_owner_group: null,
                error: error.message || 'Unknown error'
            };
        }
    });

    Promise.all(fetchPromises)
        .then(async (results) => {
            let productMissingEnv = [];
            let productOwnerMissingEnv = [];
            let adGroups = [];

            // Check product existence for create new proxy
            if (isCreateNewProxy) {
                results.forEach(result => {
                    if (result.name === proxyGroupName) {
                        productMissingEnv.push(result.env);
                    }
                });
                if (Array.isArray(productMissingEnv) && productMissingEnv.length > 0) {
                    classObject.setState({ singleProductExistsEnvError: true });
                    classObject.props.updateStore({ isSubmit: true });
                    classObject.setState({ singleProxyEnv: productMissingEnv.join(",") });
                    return;
                }
            }

            // Check proxies and product owner group for each env
            results.forEach(result => {
                if (Array.isArray(result.proxies) && result.proxies.length > 0 && result.proxies.includes(proxyName)) {
                    productMissingEnv.push(result.env);
                }
                if (!result.product_owner_group) {
                    productOwnerMissingEnv.push(result.env);
                } else {
                    adGroups.push(result.product_owner_group);
                }
            });

            let adGroupResult = {};

            results.forEach(({ env, product_owner_group }) => {
                adGroupResult[env] = product_owner_group;
             });

            classObject.setState({ singleProductEnv: productMissingEnv.join(",") });

            // check if onlyenve is having product owner and assign it as is.
            if(null !== adGroupResult && Object.keys(adGroupResult).length !== 0 ){

              if(selectedEnvs && selectedEnvs.length === 1){
                // When only single environments are selected
                 const nonNullValues = Object.values(adGroupResult).filter(value => value !== null);
              if(nonNullValues.length > 0){
                 const adGroupValue = adGroupResult[selectedEnvs[0]];
                 classObject.props.updateStore({ adGroup: adGroupValue });
                 classObject.setState({ adGroup: adGroupValue });
                 classObject.setState({ customAdGroup: false });
              } else {
                 classObject.setState({ customAdGroup: true });
                 classObject.props.updateStore({ adGroup: '' });
                 classObject.setState({ adGroup: '' });
                 classObject.props.updateStore({ isSubmit: true });
              }
              } else if(selectedEnvs && selectedEnvs.length > 1){
                // Check if adGroupResult has same value for product_owner_group
                const nonNullValues = Object.values(adGroupResult).filter(value => value !== null);
                let commonAdGroupValue = null;
                if (nonNullValues.length > 0) {
                    const uniqueValues = [...new Set(nonNullValues)];
                    if (uniqueValues.length === 1  && nonNullValues.length === selectedEnvs.length) {
                        // All non-null values are the same and pick one as value for AD group
                        commonAdGroupValue = uniqueValues[0];
                        classObject.props.updateStore({ adGroup: commonAdGroupValue });
                        classObject.setState({ adGroup: commonAdGroupValue });
                        classObject.setState({ customAdGroup: false });
                    } else {

                      if(uniqueValues.length === selectedEnvs.length ){
                        //All values are equal take unique value
                       classObject.props.updateStore({ adGroupMismatchOptions: uniqueValues });
                       classObject.setState({ adGroupMismatchOptions: uniqueValues });
                       classObject.setState({ customAdGroup: true });
                    } else if (uniqueValues.length < selectedEnvs.length ){
                      // All values are not equal show dropdown with available
                       classObject.props.updateStore({ adGroupMismatchOptions: uniqueValues });
                       classObject.setState({ adGroupMismatchOptions: uniqueValues });
                       classObject.setState({ customAdGroup: true });
                    }
                    }
                } else {
                      classObject.setState({ customAdGroup: true });
                      classObject.props.updateStore({ adGroup: '' });
                      classObject.setState({ adGroup: '' });
                      classObject.props.updateStore({ isSubmit: true });
                }
              }
            } else{
              //Negative case which dosent occur or handle if needed later
              console.log("adGroupResult is null or empty");
            }

            if ( adGroupResult && Object.values(adGroupResult).every((v) => v === null) ) {
                  // All values are null, set productOwnerMissingEnv to adGroupResult as-is
                  classObject.setState({ productOwnerMissingEnv: JSON.stringify(adGroupResult) });
              } else {
                  // Construct response with only non-null key-value pairs
                  const filtered = Object.entries(adGroupResult || {})
                      .filter(([_, v]) => v !== null)
                      .reduce((acc, [k, v]) => {
                          acc[k] = v;
                          return acc;
                      }, {});
                  classObject.setState({ productOwnerMissingEnv: JSON.stringify(filtered) });
              }

          if (!apiFetchFailed && Array.isArray(productOwnerMissingEnv) && productOwnerMissingEnv.length > 0) {

                classObject.props.updateStore({ isSubmit: true });
                classObject.setState({ customAdGroup: true });
            }

            if (Array.isArray(productMissingEnv) && productMissingEnv.length > 0) {
                classObject.setState({ singleProductEnvError: true });
                classObject.props.updateStore({ isSubmit: true });
                classObject.setState({ customAdGroup: false });
            }
        });
}


   const fetchLambdaApis = async (apiName, path, buildBody) => {

        try {
            const { fetchAuthSession } = await import('@aws-amplify/auth');
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();

            const myInit = {
                headers: {
                    'Content-Type': 'application/json',
                    ...(idToken ? { Authorization: idToken } : {}),
                },
                responseType: 'json', // Force Amplify to parse response as JSON
            };

            // Add body only if buildBody is provided
            let restOperation;

            if (buildBody) {
                myInit.body = buildBody;
                // Make the POST API call using Amplify's post method
                restOperation = post({
                    apiName,
                    path,
                    options: myInit
                });
            } else {
                // Make the GET API call using Amplify's get method
                restOperation = get({
                    apiName,
                    path,
                options: myInit
              });
           }
            // Await the response and access the body
            const { body } = await restOperation.response;
            const data = await body.json();

            return data;

        } catch (error) {
            console.error('Error fetching Lambda APIs:', error);
            throw error;
        }
    };

// Method to fetch AD Groups from the API using the same pattern as Summary.jsx
   const fetchAdGroups = async (classObject) => {
        classObject.setState({ isLoadingAdGroups: true });
        const apiName = 'Get Users From Claims API';
        const path = '';
        try {

           const data = await fetchLambdaApis(apiName, path, null);

            // Handle the specific API response format
            let options = [];
            if (data && data.user && Array.isArray(data.user.adGroups)) {
                // Transform the adGroups array into options format for react-select
                options = data.user.adGroups.map(groupName => ({
                    value: groupName,
                    label: groupName
                }));
            } else {
                console.warn('AD Groups API response is not in expected format. Expected: {user: {adGroups: []}}', data);
            }

            classObject.setState({
                adGroupOptions: options,
                isLoadingAdGroups: false
            });
        } catch (error) {
            console.error('Error fetching AD Groups:', error);
            classObject.setState({ isLoadingAdGroups: false });
        }
    };

const SCM_PREFIX_PATTERN = /github?/;

const GITHUB_REPO_PATTERN = /\/(?<repo>[^/]+)\.git/;

const GIT_PROJECT_REPO_PATTERN = /\/(?<project>[^/]+)\/(?<repo>[^/]+)\.git/;

const getRepositoryNameFromGitHubUrl = (giturl) => {
  return getNamedGroupFromSubject(giturl, GITHUB_REPO_PATTERN, "repo");
};

const getRepositoryNameFromGitUrl = (giturl) => {
  return getNamedGroupFromSubject(giturl, GIT_PROJECT_REPO_PATTERN, "repo");
};

const getProjectNameFromGitUrl = (giturl) => {
  if (isBitbucketOrGithub(giturl, SCM_PREFIX_PATTERN) == "github") {
    return getRepositoryNameFromGitHubUrl(giturl);
  } else {
    return getNamedGroupFromSubject(
      giturl,
      GIT_PROJECT_REPO_PATTERN,
      "project"
    );
  }
};

const getNamedGroupFromSubject = (subject, pattern, namedGroup) => {
  let match = pattern.exec(subject);
  if (match) {
    return match.groups[namedGroup];
  }
};

const isValidGitUrl = (url) => {
  return url && getProjectNameFromGitUrl(url);
};

const isBitbucketOrGithub = (subject, pattern) => {
  let match = pattern.exec(subject);
  if (match) {
    return match;
  }
};

const isDuplicateConsumer = (consumer, consumersList) => {
  const duplicates = consumersList
    .map((consumer) => consumer.label)
    .filter((element, index, array) => array.lastIndexOf(element) !== index);
  return duplicates.includes(consumer);
};

const checkValueInApis = (consumer, testConsumerList, pilotConsumerList) => {
  const testConsumers = testConsumerList.map((consumer) => consumer.label);
  const pilotConsumers = pilotConsumerList.map((consumer) => consumer.label);
  if (consumer === "") {
    return false;
  }
  if (testConsumers.includes(consumer) && pilotConsumers.includes(consumer)) {
    return false;
  } else {
    return true;
  }
};

const retrieveDomainName = () => {
  const domainNameStr = window.location.hostname;
  let domainName = "";
  if (domainNameStr === "apigateway.workforce.dev.principal.com") {
    domainName = "dev";
  } else if (domainNameStr === "apigateway.workforce.staging.principal.com") {
    domainName = "staging";
  } else if (domainNameStr === "apigateway.workforce.principal.com") {
    domainName = "prod";
  } else {
    domainName = "dev";
  }
  return domainName;
};

const retrieveQueryParams = () => {
  let query = window.location.href.split("?")[1];
  let unmask = atob(query);

  let queryParamsJsonArray = [];

  if (null != unmask && unmask.includes("&")) {
    queryParamsJsonArray = unmask.split("&");
    let queryparamsJson = {};

    for (let i = 0; i < queryParamsJsonArray.length; i++) {
      let key = "";
      let value = "";

      if (null != queryParamsJsonArray[i].split("=")[0]) {
        key = queryParamsJsonArray[i].split("=")[0];
        if (queryParamsJsonArray[i].split("=")[1]) {
          value = queryParamsJsonArray[i].split("=")[1];
        }
      }
      queryparamsJson[key] = value;
    }
    return queryparamsJson;
  }
};

const approvalStatusAPICall = async (data, buildBody, apiName, path) => {
  try {
    //const { fetchAuthSession } = import("@aws-amplify/auth");

    // Await the response and access the body
    const response = await fetchLambdaApis(apiName, path, buildBody);

    return response;
  } catch (error) {
    console.error("API error:", error);

    let responseErrorBody = {};
           responseErrorBody = {
            status: Utils.FAILED
          };
    if (error.response && error.response.body) {
       let errorResponseData ={};
      try {
         errorResponseData = error.response.body.json();
        console.error("Error response body:", errorResponseData);
         responseErrorBody = {
            status: errorResponseData.status
          };
         return responseErrorBody;
      } catch (parseError) {
        console.error(
          "Could not parse error response body:",
          error.response.body
        );
        return responseErrorBody.status;
      }
    }

    return responseErrorBody.status;
    //alert("Failed to call API. Please try again.");
  }
};

const isFutureTimestamp = (createdAtTimestamp) => {
  const today = new Date();
  const todayTimestamp = today.getTime();
  const createdAtDate = new Date(createdAtTimestamp);
  const todayDate = new Date(todayTimestamp);
  var result =  createdAtDate >= todayDate;
  //TO Ensure timestamp is not in the future
  return result;
};

const isRequestExpired = (createdAt) => {
  const currentTimestamp = Date.now();
  const currentDate = new Date(currentTimestamp);
  const createdAtDate = new Date(createdAt);

  const timeDifference = Math.abs(
    createdAtDate.getTime() - currentDate.getTime()
  );
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  return daysDifference;
};

const FETCH_STATUS = "fetch_status";
const APPROVAL = "approve";
const DENIAL = "deny";
const FAILED = "failed";
const APPROVED = "approved";
const DENIED = "denied";

const Utils = {};
Utils.constructComponentName = constructComponentName;
Utils.getRepositoryNameFromGitUrl = getRepositoryNameFromGitUrl;
Utils.getProjectNameFromGitUrl = getProjectNameFromGitUrl;
Utils.isValidGitUrl = isValidGitUrl;
Utils.constructProxyGroupPrefix = constructProxyGroupPrefix;
Utils.getRepositoryNameFromGitHubUrl = getRepositoryNameFromGitHubUrl;
Utils.constructConsumerOrProxyGroupName = constructConsumerOrProxyGroupName;
Utils.isDuplicateConsumer = isDuplicateConsumer;
Utils.checkValueInApis = checkValueInApis;
Utils.retrieveDomainName = retrieveDomainName;
Utils.retrieveQueryParams = retrieveQueryParams;
Utils.approvalStatusAPICall = approvalStatusAPICall;
Utils.isRequestExpired = isRequestExpired;
Utils.isFutureTimestamp = isFutureTimestamp;
Utils.constructProxyComponentName = constructProxyComponentName;
Utils.constructProductComponentName = constructProductComponentName;
Utils.validateProxyExistsWithProduct = validateProxyExistsWithProduct;
Utils.validateIfProxyAlreadyExists = validateIfProxyAlreadyExists;
Utils.fetchAdGroups = fetchAdGroups;
Utils.fetchLambdaApis = fetchLambdaApis;

Utils.FETCH_STATUS = FETCH_STATUS;
Utils.APPROVAL = APPROVAL;
Utils.DENIAL = DENIAL;
Utils.FAILED = FAILED;
Utils.APPROVED = APPROVED;
Utils.DENIED = DENIED;

export default Utils;